import Pqp from "../../../../3x1010/Pqp.js";

export default class Bar {
	constructor(target, templateBar, icon, nock, min, max, start) {
		this.target = target;
		this.templateBar = templateBar;
		this.icon = icon;
		this.nock = nock;
		this.min = min;
		this.max = max;
		this.value = start;
		if (Pqp.isNullOrEmpty(this.value)) {
			this.value = max;
		}
		this.clips = new Array();


	}

	init() {
		this.mc = jQuery(this.templateBar).clone();
		this.mc.attr("id", "bar" + Bar.ENUM++);
		this.target.append(this.mc);
		jQuery(".js-icon", this.mc).css("background-image", "url('./assets/ui/bars/" + this.icon + "')");

		let tmp = this.value
		this.setValue(0);
		this.setValue(tmp);
	}

	setValue(value) {
		if (value !== this.value) {
			this.value = value;
			let num = Math.ceil(value / this.max * Bar.NUM_NOCKS);
			if (value === this.max) {
				num++;
			}
			this.removeClips();
			for (let x = 0; x < num; x++) {
				let nock = jQuery("#template-nock").clone();
				nock.attr("id", Bar.ENUM++);
				this.clips.push(nock);
				jQuery(".js-nockes", this.mc).append(nock);
				nock.css({ left: 11 * x });
				nock.css("background-image", "url('./assets/ui/bars/" + this.nock + "')");
			}
		}

	}

	removeClips() {
		for (let x = 0; x < this.clips.length; x++) {
			this.clips[x].remove();
		}
		this.clips = new Array();
	}


}

Bar.NUM_NOCKS = 12;
Bar.ENUM = 0;